import styled from "styled-components"
import media from "styled-media-query"

export const NavMenu = styled.nav`
  width: calc(100% - 40px);
  display: flex;
  justify-content: center;
  align-items: center;

  .logo {
    margin-top: 15px;
  }

  ${media.greaterThan("large")`
    justify-content: space-between;
    max-width: 1240px;
  `}

  > .menu-list {
    display: none;
    ${media.greaterThan("large")`
      display: flex;
      align-items: center;
      list-style-type: none;
      > .item {
        list-style-type: none;
        a, button {
          background-color: transparent;
          border: none;
          font-size: 16px;
          cursor: pointer;
          color: #f1f1f1;
          text-decoration: none;
          font-family: Lato;
          font-weight: bold;
          padding: 22px 12px;
            transition: all .15s ease-in-out;
          &:first-child {
            padding-left: 0;
          }
          &:last-child {
            color: #F3AE0B;
            padding-right: 0;
          }

          &:hover {
            color: #00AAF7;
            transition: all .15s ease-in-out;
          }
        }
      }
    `}
  }
`

export const TopHeader = styled.header`
  background-color: #171717;
  box-shadow: 0 8px 34px rgba(0, 0, 0, 0.35);
  width: 100%;
  height: 72px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
`
